import React, { Component } from "react";
import { DKLabel } from "deskera-ui-library";
import SegmentControl from "../../common/SegmentControl";
import Incrementor from "../../common/Incrementor";
import { PAGE_ELEMENT } from "../ComponentList";

/*
PROPS
- data // this is current componets data
- onDataChange
- onClose
*/

class TextEditor extends Component {
  constructor(props) {
    super(props);
    this.componentData = this.props.data;
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  render() {
    return (
      <div className="parent-width mt-l">
        {/* ////////////////////////////////////////////////////////////////////////////////////////// */}

        {this.componentData.type === PAGE_ELEMENT.BUTTON && (
          <div className="parent-width column border-box border-m p-r shadow-s border-radius-s mb-l">
            <DKLabel text="Title" className="fw-m" />
            <textarea
              type="text"
              className="border-none bg-gray1 border-m parent-width parent-height border-radius-s border-box p-v-s p-h-s mt-s"
              style={{
                minHeight: 50,
                fontSize: 13,
                resize: "none",
              }}
              value={this.componentData.value}
              onChange={(e) => {
                this.changeValue(e.target.value);
              }}
            />
          </div>
        )}
        {/* ////////////////////////////////////////////////////////////////////////////////////////// */}

        <div className="border-box parent-width border-m shadow-s p-r border-radius-s">
          <div className="row">
            <DKLabel text={`Color:`} className="fw-m" />
            <input
              type="color"
              className="ml-r"
              value={this.componentData.style.color}
              onChange={(e) => this.changeStyle("color", e.target.value)}
            />
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////// */}

          <Incrementor
            className="mt-l"
            title="Font Size"
            value={this.componentData.style.fontSize}
            onChange={(value) => {
              this.changeStyle("fontSize", value);
            }}
          />
          {/* ////////////////////////////////////////////////////////////////////////////////////////// */}

          <DKLabel text="Text Alignment" className="fw-m mt-l mb-s" />
          <SegmentControl
            data={[
              { title: "Left", value: "left" },
              { title: "Center", value: "center" },
              { title: "Right", value: "right" },
            ]}
            onChange={(value) => {
              this.changeStyle("textAlign", value);
            }}
            value={this.componentData.style.textAlign}
          />
          {/* ////////////////////////////////////////////////////////////////////////////////////////// */}

          <DKLabel text="Font Weight" className="fw-m mt-l mb-s" />
          <SegmentControl
            data={[
              { title: "Bold", value: "bold" },
              { title: "Medium", value: "600" },
              { title: "Normal", value: "normal" },
            ]}
            onChange={(value) => {
              this.changeStyle("fontWeight", value);
            }}
            value={this.componentData.style.fontWeight}
          />
        </div>

        {/* ////////////////////////////////////////////////////////////////////////////////////////// */}
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  changeStyle = (property, value) => {
    let style = { ...this.componentData.style };
    style[property] = value;
    this.componentData.style = style;
    this.props.onDataChange(this.componentData);
  };

  //////////////////////////////////////////////////////////////////////////////////////////

  changeValue = (value) => {
    this.componentData.value = value;
    this.props.onDataChange(this.componentData);
  };

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
}

export default TextEditor;
